import { render, staticRenderFns } from "./analysis-income.vue?vue&type=template&id=23fe6213&scoped=true&"
import script from "./analysis-income.vue?vue&type=script&lang=js&"
export * from "./analysis-income.vue?vue&type=script&lang=js&"
import style0 from "./analysis-income.vue?vue&type=style&index=0&id=23fe6213&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe6213",
  null
  
)

export default component.exports